// Accounts created via SSO providers that don't supply a real email address
// (wallet, Telegram, and — soon — Steam) come back from the backend with a
// synthetic placeholder address on a reserved sub-domain. These users must
// complete their account (add a real email via the complete-account flow)
// before they can use email-bound features like 2FA — see
// wallet-sso-api-contract.md §§2-3. The backend mirrors this guard
// server-side (requireCompletedAccount on /2fa/setup), so a synthetic account
// that slips past the UI still gets a 400.
//
// To add a future provider, append its sub-domain here — every consumer reads
// this single list.
export const SYNTHETIC_EMAIL_DOMAINS = [
  '@wallet.outpoll.com',
  '@telegram.outpoll.com',
  '@steam.outpoll.com',
] as const;

/**
 * True when `email` is a backend-issued synthetic placeholder (wallet /
 * Telegram / Steam SSO), i.e. the account has no real email yet.
 */
export function isSyntheticEmail(email?: string | null): boolean {
  if (!email) return false;
  // Case-insensitive: email domains are case-insensitive, so don't let a
  // non-lowercase host (e.g. addr@Wallet.outpoll.com) slip past the guard.
  const normalized = email.toLowerCase();
  return SYNTHETIC_EMAIL_DOMAINS.some((domain) => normalized.endsWith(domain));
}
